import { render, staticRenderFns } from "./EmployeeList2.vue?vue&type=template&id=c489db8c&scoped=true"
import script from "./EmployeeList2.vue?vue&type=script&lang=js"
export * from "./EmployeeList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c489db8c",
  null
  
)

export default component.exports